module.exports = __webpack_public_path__ + "static/vargas-f7bbbd57b5894213b3f3baecb7933a50.png";